<template>
<div class="fc-alacarte-container">
	<div class="fc-product-list">
		<div class="fc-list" v-if="products != null && products != undefined && products.length > 0">
			<div v-for="item in products">
				<div>
					<img :src="item.PhotoKey" />
				</div>
				<div>
					<div class="fc-title">{{ item.ProductName }}</div>
					<div class="fc-price">${{ item.ProductsMainOptions[0].BasePrice.toFixed(2) }}</div>
					<div class="fc-desc" v-html="item.Description.replace(/\r\n/g, '<br/>')"></div>
					<div class="fc-add-to-cart">
						<div class="fc-quantity">
							<a @click="(item.quantity) > 1 ? (item.quantity -= 1) : 1" v-bind:class="{'fc-active': (item.quantity > 1)}"></a>
							<span>{{ item.quantity }}</span>
							<a @click="item.quantity += 1" class="fc-active"></a>
						</div>
						<div class="fc-control" @click="makeCustomize(item)">
							ADD TO CART
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
  <fc-customize v-if="showCustomize" :productId="productId" :optionId="optionId" v-on:cancel="showCustomize = false"></fc-customize>
</div>
</template>
<script>
import { mapMultiRowFields } from 'vuex-map-fields'
import CustomizeComponent from './Customize'

export default {
  name: 'ala-carte',
  components: {
    'fc-customize': CustomizeComponent
  },
  data () {
    return {
      showCustomize: false,
      productId: 0,
      optionId: 0
    }
  },
  methods: {
    makeCustomize (product) {
      const optionId = product.ProductsMainOptions.length > 0 ? product.ProductsMainOptions[0].ProductsMainOptionId : 0

      const data = {
        productId: product.ProductId,
        optionId: optionId
      }
      this.$store.dispatch('product/getProductDetails', data)
        .then(a => {
          if (a.ProductsOptions !== null && a.ProductsOptions.length > 0) {
            this.productId = product.ProductId
            this.optionId = optionId
            this.showCustomize = true
          } else {
            this.addToCart(product)
          }
        })
    },
    addToCart (product) {
      const optionId = product.ProductsMainOptions.length > 0 ? product.ProductsMainOptions[0].ProductsMainOptionId : 0
      const data = {
        ProductId: product.ProductId,
        ProductsMainOptionId: optionId,
        Qty: product.quantity,
        OptionsVariantIds: [],
        BoxName: ''
      }
      this.$store.dispatch('cart/addProductToCart', data)
    }
  },
  computed: {
    ...mapMultiRowFields('product',
      {
        products: 'products.Products'
      }
    )
  }
}
</script>


// WEBPACK FOOTER //
// src/components/product/AlaCarte.vue